import React from 'react';
import { Link } from 'react-router-dom';
import { Trash2 } from 'lucide-react';
import MessageRenderer from './MessageRenderer';

const MessageList = ({
    messages,
    showLengthWarning,
    error,
    audioStates,
    copiedStates,
    ttsSettings,
    onDismissWarning,
    onAudioToggle,
    onCopy,
    getAudioIconType,
    onSavePrompt,
    onSaveToNotes,
    messagesEndRef
}) => {
    return (
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
            {/* Length Warning Banner */}
            {showLengthWarning && (
                <div className="sticky top-0 z-10 bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-700 rounded-lg p-3 mb-4 flex items-center justify-between">
                    <p className="text-sm text-blue-700 dark:text-blue-300">
                        Chats are getting long! Consider starting a{' '}
                        <Link
                            to="/dashboard/unified-chat"
                            className="font-semibold underline hover:text-blue-800 dark:hover:text-blue-200"
                        >
                            New Chat
                        </Link>
                        {' '}for new topics to ensure optimal performance.
                    </p>
                    <button
                        onClick={onDismissWarning}
                        className="text-blue-500 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-200"
                    >
                        <Trash2 size={16} />
                    </button>
                </div>
            )}

            {/* Messages */}
            {messages.map((message) => (
                <MessageRenderer
                    key={message.id}
                    message={message}
                    audioStates={audioStates}
                    copiedStates={copiedStates}
                    ttsSettings={ttsSettings}
                    onAudioToggle={onAudioToggle}
                    onCopy={onCopy}
                    getAudioIconType={getAudioIconType}
                    onSavePrompt={message.isUser ? onSavePrompt : undefined}
                    onSaveToNotes={onSaveToNotes}
                />
            ))}

            {/* Error message display */}
            {error && !messages.some(m => m.isError) && (
                <div className="bg-red-100 dark:bg-red-900/30 p-3 rounded-lg border border-red-200 dark:border-red-700 text-red-700 dark:text-red-300 text-sm">
                   Error: {error}
                </div>
            )}
            
            <div ref={messagesEndRef} />
        </div>
    );
};

export default MessageList;